import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
    },
    content: {
      position: "relative",
      display: "flex !important",
      flexDirection: "column",
      alignItems: "center",
      flexGrow: 1,
      maxWidth: "548px !important",
      paddingTop: 24,
    },
    justifyText: {
      textAlign: "justify",
    },

    '@keyframes scaleSvg': {
      '0%': {
        transform: 'scale(1.0) ',

      },
      '100%': {
        transform: 'scale(1.2) '
      }
    },
    inputsContainer: {
      flexGrow: 1,
      backgroundColor: "#FFFFFF",
      borderRadius: "10px",
      border: "2px dashed #000000",
      maxHeight: 500,
      width: '100%',

      '& svg.qutation__icon': {
        // transform: 'rotate(90deg)',
        fontSize: '32px',
        position: 'absolute',
        zIndex: 1,
        top: '14px',
        fill: '#00E5E0',
        left: '22px',
        cursor: 'pointer',
        animation: `$scaleSvg 1.2s ease-in-out infinite alternate`,

      },

    },

    inputContainer: {
      position: "relative",
      width: "100%",
      height: "100%",
      '& svg.icon__capture': {
        position: 'absolute',
        bottom: '7px',
        right: '45%',
        width: '45px',
        height: '45px',
        cursor: 'pointer',
        fill: '#ffffff'
      }

    },
    actionBar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      margin: "24px 0",
      "& > .last": {
        marginRight: "auto",
      },
    },
    "@media(max-width:768px)": {
      inputsContainer: {
        maxHeight: "calc(100vw - 32px)",
      },
      actionBar: {
        position: "fixed",
        bottom: 0,
        padding: "8px 16px",
        backgroundColor: "rgb(229, 242, 253)",
        margin: 0,
      },
    },
  })
);
